import setSearchText from '../actions/setSearchText';
import { getStore as getSearchStore } from '../store/Store';
import { mutator } from 'satcheljs';

/**
 * Mutator which sets the search text in the store
 */
export default mutator(
    setSearchText,
    function setSearchTextMutator({ text: searchText }: { text: string }) {
        getSearchStore().searchText = searchText || '';
    }
);
